// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1___45dd1f46a605ebfa434","cls2":"ResearchInterestTags-cls2__a1b38b69eeb60d454833 ResearchInterestTags-cls1___45dd1f46a605ebfa434"};